import { Component, Input, OnInit, QueryList, signal, ViewChild, ViewChildren } from '@angular/core';
import { Menu } from '../menu.model';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { MatAccordion, MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ToastService } from '../../Services/toast/toast.service';
import { ConnectiveservicesService } from '../../Services/Apis/Connectiveservices/connectiveservices.service';
import { TranslatePipe } from '../../components/Utilites/Pipe/translate.pipe';
@Component({
  selector: 'app-menu-items',
  imports: [
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatExpansionModule,
    RouterModule,
    CommonModule,
    TranslatePipe
    // MenuItemsComponent
  ],
  templateUrl: './menu-items.component.html',
  styleUrl: './menu-items.component.scss'
})
export class MenuItemsComponent implements OnInit {

  @Input() menu: Menu = [];
  readonly panelOpenState = signal(false);
  currentRoute: string = '';
  expandedPanel: string | null = null;
  // @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChildren(MatExpansionPanel) panels!: QueryList<MatExpansionPanel>;

  constructor(
    private router: Router,
    private toast: ToastService,
    private connectiveServices: ConnectiveservicesService
  ) { }

  ngOnInit(): void {
    this.router.events?.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateActiveRoute();
    });

    // Initialize the active route
    this.updateActiveRoute();
  }

  // Update the current active route
  updateActiveRoute() {
    this.currentRoute = this.router.url;
  }

  // Navigate to the selected route
  navigateToRoute(link: any) {
    //  this.accordion.closeAll();
    this.onToggleClick(link);
    this.panels.forEach(panel => panel.close());
    this.router.navigate([link.link]);
  }

  // Check if the route is active
  isActive(link: any): boolean {
    // return this.currentRoute === link.link;
    return this.isRouteActive(link.link);
  }

  private isRouteActive(path: string): boolean {
    // You can check if the current URL starts with the given path
    return this.currentRoute.startsWith(path);
  }

  onToggleClick(item: any) {
    const subOrg = sessionStorage.getItem('SubOrgData');
    const subOrgData = subOrg ? JSON.parse(subOrg) : null;

    if (this.connectiveServices.getuserdata()?.data?.user_role != "STUDENTS") {
      if (item.match_key === 'COLLEGE_MANAGEMENT_SYSTEM' && subOrgData?.id == null) {
        item.expanded = false;
        this.toast.showToast('danger', 'Please select the sub organization to access this module');
      } else if (item.match_key === 'ACADEMICS' && subOrgData?.id == null) {
        item.expanded = false;
        this.toast.showToast('danger', 'Please select the sub organization to access this module');
      } else {
        this.menu.forEach((items: any) => {
         if (items.match_key !== item.match_key) {
             items.expanded = false;
        }else{
             items.expanded = !items.expanded;
        }
      }); 
      }
    } else {
      this.menu.forEach((items: any) => {
         if (items.match_key !== item.match_key) {
             items.expanded = false;
        }else{
             items.expanded = !items.expanded;
        }
      }); 
    }
  }
}
